export default "__VITE_ASSET__AaS7IyBO__"